import React, { useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Login from './components/Login';
import './App.css';
import DashboardMD from './screens/managingDirector/dashboard';
import MarketingCRMDashboard from "./screens/marketingCRM/dashboard";
import SalesDashboard from './screens/sales/dashboard';
import PurchaseDashboard from './screens/purchaseDashboard/purchase_dashboard';
import QualityManagementDashboard from './screens/qualitymanagement/dashboard';
import AccountManagerDashboard from './screens/AccountsManager/dashboard';
import GeneralManagerDashboard from './screens/GeneralManager/gmdashboard';
import ProductionManagerDashboard from './screens/production_dashboard/pmdashboard';
import NDPDashboard from './screens/ndp/dashboard';
import StoreDashboard from './screens/store/dashboard';
import CustomerDashboard from './screens/customer/dashboard';
import EmployeeDashboard from './screens/employee/dashboard';
import SupervisorDashboard from './screens/supervisor/dashboard';
import HRDashboard from './screens/hr/dashboard';
import MaintenanceDashboard from './screens/maintenance/dashboard';
import SecurityDashboard from './screens/security/dashboard';
import { clearUser } from './redux/slices/userSlice';
import { clearNavigation } from './redux/slices/navigationSlice';  // FIXED: Changed from clearNavigation to clearAllNavigation

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, userData } = useSelector(state => state.user);

  const handleLogout = useCallback(() => {
    dispatch(clearUser());
    dispatch(clearNavigation());  // Changed from clearAllNavigation
  }, [dispatch]);

  // Helper function to check if user is authenticated
  const isAuthenticatedCheck = useCallback(() => {
    return isAuthenticated;
  }, [isAuthenticated]);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Login Route */}
          <Route 
            path="/login" 
            element={
              isAuthenticatedCheck() ? (
                <Navigate to={userData?.defaultRoute || "/dashboard"} replace />
              ) : (
                <Login />
              )
            } 
          />
          
          {/* Main Dashboard */}
          {/* Managing Director Dashboard */}
          <Route 
            path="/managing-director" 
            element={
              isAuthenticatedCheck() ? (
                <DashboardMD user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* General Manager Dashboard */}
          <Route 
            path="/gmdashboard" 
            element={
              isAuthenticatedCheck() ? (
                <GeneralManagerDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Purchase Dashboard */}
          <Route
            path="/purchase" 
            element={
              isAuthenticatedCheck() ? (
                <PurchaseDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          
          {/* Store Dashboard */}
          <Route 
            path="/store-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <StoreDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Production Dashboard */}
          <Route 
            path="/pmdashboard" 
            element={
              isAuthenticatedCheck() ? (
                <ProductionManagerDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Sales Dashboard */}
          <Route 
            path="/sales" 
            element={
              isAuthenticatedCheck() ? (
                <SalesDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Marketing Dashboard */}
          <Route 
            path="/marketing-crm" 
            element={
              isAuthenticatedCheck() ? (
                <MarketingCRMDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Quality Dashboard */}
          <Route 
            path="/qualitymanagement" 
            element={
              isAuthenticatedCheck() ? (
                <QualityManagementDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Accounts Dashboard */}
          <Route 
            path="/AccountsManager" 
            element={
              isAuthenticatedCheck() ? (
                <AccountManagerDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* HR Dashboard */}
          <Route 
            path="/hr-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <HRDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Employee Dashboard */}
          <Route 
            path="/employee-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <EmployeeDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Supervisor Dashboard */}
          <Route 
            path="/supervisor-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <SupervisorDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Customer Dashboard */}
          <Route 
            path="/customer-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <CustomerDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Maintenance Dashboard */}
          <Route 
            path="/maintenance-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <MaintenanceDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Security Dashboard */}
          <Route 
            path="/security-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <SecurityDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* NDP Dashboard */}
          <Route 
            path="/ndp-dashboard" 
            element={
              isAuthenticatedCheck() ? (
                <NDPDashboard user={userData} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Default Route */}
          <Route 
            path="/" 
            element={
              isAuthenticatedCheck() ? (
                <Navigate to={userData?.defaultRoute || "/dashboard"} replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;